import { useClientFeedbackContext } from '../../contexts/ClientFeedbackProvider';
import { ClientFeedback } from '../../types/feedbacks';

const ClientFeedbackHolder = ({ feedback }: { feedback: ClientFeedback }) => {
  // integration of context hooks here
  const { setShowClientFeedbackModal, setClientFeedback } =
    useClientFeedbackContext();

  // handler function to handle modal showing declared here
  const modalShowingHandler = () => {
    setShowClientFeedbackModal(true);
    setClientFeedback(feedback);
  };

  // rendering client feedback holder component here
  return (
    <div>
      <button
        onClick={modalShowingHandler}
        className='font-medium text-base-light-blue hover:opacity-70 active:scale-95 duration-300'
      >
        {feedback.client_full_name}
      </button>
    </div>
  );
};

export default ClientFeedbackHolder;
